// Integration SKUs that have a configuration page at /system/integrations/<sku>.
// Marketplace integration apps without a page here (e.g. interalp) get no settings link.
export const CONFIGURABLE_INTEGRATION_SKUS = new Set([
    'apaleo',
    'asa',
    'casablanca',
    'elite',
    'fias',
    'fidelio',
    'gastrodat',
    'hobex',
    'incert',
    'mews',
    'ohip',
    'protel',
    'simphony',
    'stripe',
])
